import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  button_container: {
    position: "relative",
    boxShadow: theme.palette.error.main,
    textTransform: "none",
    fontWeight: "bold",
    borderRadius: "4px",
    lineHeight: "24px",
    backgroundColor: theme.palette.primary.main,
    color: "#FBFDFC",
    height: "50px",
    letterSpacing: 0,
    border: "none",
    cursor: "pointer",
    padding: "0px 24px",
    fontSize: "18px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: (theme as any).boxShadow.secondary,
    },
    [theme.breakpoints.down("desktop")]: {
      width: "100%",
    },
  },
  mapButton: {
    height: "50px",
    width: "88vw",
    borderRadius: "4px",
    backgroundColor: "#00833E",
    boxShadow: "0 0 12px 0 rgba(108,116,133,0.24)",
    zIndex: 10,
    position: "absolute",
    bottom: 30,
    left: "6%",
  },
  regularButton: {
    width: "239px",
    fontSize: "20px",
    height: "50px",
  },
  mobileFullWidth: {
    width: "239px",
    fontSize: "20px",
    height: "50px",
    [theme.breakpoints.down("desktop")]: {
      width: "100%",
    },
  },
  whiteButton: {
    width: "239px",
    fontSize: "20px",
    height: "50px",
    border: "1.14px solid #424242",
    background: "#fff",
    color: "#353535",
    fontWeight: "normal",
    "&:hover": {
      backgroundColor: "#fff",
      boxShadow: (theme as any).boxShadow.secondary,
    },
  },
  smallButton: {
    width: "191px",
    fontSize: "20px",
    height: "43px",
  },
  smallestButton: {
    width: "143px",
    fontSize: "16px",
    height: "43px",
  },
  disabled: {
    cursor: "initial",
    opacity: 0.3,
  },
  loader: {
    position: "absolute",
    top: 9,
    right: 9,
  },
  btnIcon: {
    width: 16,
    height: "auto",
  },
}));

export default useStyles;
